import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, CheckCircle2 } from "lucide-react";
import { AnimatedCounter } from "./AnimatedCounter";
import { EditableText, EditableImage } from "./live/Editable";

const gallery = [
  "https://images.unsplash.com/photo-1597058557804-95ac4ee36e66?crop=entropy&cs=srgb&fm=jpg&q=85&w=600",
  "https://images.unsplash.com/photo-1690356107685-3725367f6f3f?crop=entropy&cs=srgb&fm=jpg&q=85&w=600",
  "https://images.pexels.com/photos/35216547/pexels-photo-35216547.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=600",
];

export default function AboutSection() {
  return (
    <section className="relative py-24 overflow-hidden">
      <div className="absolute top-20 -right-20 w-72 h-72 bg-yellow-100 rounded-full blur-3xl" />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <div className="relative h-[480px]">
            <EditableImage
              path="home.about.image1"
              src={gallery[0]}
              alt="Students learning"
              className="absolute top-0 left-0 w-3/5 h-2/3 rounded-3xl overflow-hidden shadow-xl"
              imgClassName="w-full h-full object-cover"
            />
            <EditableImage
              path="home.about.image2"
              src={gallery[1]}
              alt="Workshop"
              className="absolute bottom-0 left-12 w-2/5 h-1/2 rounded-3xl overflow-hidden shadow-xl border-4 border-white"
              imgClassName="w-full h-full object-cover"
            />
            <EditableImage
              path="home.about.image3"
              src={gallery[2]}
              alt="Training"
              className="absolute top-10 right-0 w-2/5 h-1/2 rounded-3xl overflow-hidden shadow-xl border-4 border-white"
              imgClassName="w-full h-full object-cover"
            />
            <div className="absolute bottom-4 right-6 bg-[#0B2A6B] text-white rounded-2xl p-5 shadow-2xl flex items-center gap-4 z-10">
              <div className="text-4xl font-bold text-yellow-400">
                <AnimatedCounter value={20} suffix="+" />
              </div>
              <div className="text-sm leading-tight">
                Years of
                <br />
                Excellence
              </div>
            </div>
          </div>

          <div>
            <EditableText path="home.about.kicker" as="p" className="kicker mb-3">
              Get access to high quality learning!
            </EditableText>
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[#0B2A6B] leading-tight mb-6">
              <EditableText path="home.about.heading" as="span">
                We make the people who will make in India.
              </EditableText>
            </h2>
            <EditableText
              path="home.about.body"
              as="p"
              multiline
              className="text-slate-600 leading-relaxed text-[15px] mb-6"
            >
              India has one of the world's largest populations of young people and some of the best educational institutions. Yet Indian youth find it difficult to get jobs in line with their qualifications. Kiki Centre for Technology focuses on skilling youth as per international standards — with great theoretical and practical knowledge essential for a successful career.
            </EditableText>
            <ul className="space-y-3 mb-8">
              {[
                { key: "b1", text: "Curriculum certified by HWK Koblenz, Germany" },
                { key: "b2", text: "Hands-on training on industry-grade machinery" },
                { key: "b3", text: "German-style Berufsschule work-study program" },
                { key: "b4", text: "Strong placement assistance with 60+ companies" },
              ].map((it) => (
                <li key={it.key} className="flex items-start gap-3">
                  <CheckCircle2 className="h-5 w-5 text-yellow-500 mt-0.5 shrink-0" />
                  <EditableText path={`home.about.bullet.${it.key}`} as="span" className="text-slate-700">
                    {it.text}
                  </EditableText>
                </li>
              ))}
            </ul>
            <Link
              to="/about"
              className="inline-flex items-center gap-2 px-6 py-3 rounded-lg bg-[#0B2A6B] text-white font-semibold hover:bg-[#061a47] transition group"
            >
              Read More
              <ArrowRight className="h-4 w-4 group-hover:translate-x-1 transition" />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
